import { usingGet, createProxyUrl } from '@ocean/api'
import { SessionUtils } from '@ocean/utils'
import { UserUtils } from 'utils'

export const getHomeOverview = () => usingGet('home/overview', { useProxy: true })

export const getLandingPhotoSource = (
  hasStartupImage: boolean,
  timestamp?: string
): Nullable<string> => {
  if (!hasStartupImage) return null
  const { customer } = UserUtils.getUserLoginParams()
  const sessionToken = SessionUtils.getSessionToken() || ''
  const logoTimestamp = timestamp ? new Date(timestamp).getTime() : ''
  return createProxyUrl(
    `system/customerStartupImage?token=${sessionToken}&customer=${customer}&timestamp=${logoTimestamp}`
  )
}
